import React from 'react';
import {
  View,
  StyleSheet,
  Text,
} from 'react-native';
import {useTheme} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialIcons';
import {ActionButton} from '../../shared/components/ActionButton';
import {MainLayout} from '../layouts/MainLayout';

interface DeliverySuccessScreenProps {
  navigation: any;
  route: {
    params?: {};
  };
}

export const DeliverySuccessScreen: React.FC<DeliverySuccessScreenProps> = ({
  navigation,
}) => {
  const theme = useTheme();

  const handleGoToDashboard = () => {
    navigation.navigate('Dashboard');
  };

  const handleScanAnother = () => {
    navigation.navigate('Scan');
  };

  return (
    <MainLayout navigation={navigation} title="Entrega Exitosa">
      <View style={[styles.container, {backgroundColor: theme.colors.background}]}>
        <View style={styles.content}>
          {/* Success Icon */}
          <View style={[styles.iconContainer, {backgroundColor: '#E8F5E9'}]}>
            <Icon name="check-circle" size={80} color="#4CAF50" />
          </View>

          {/* Success Message */}
          <Text style={[styles.title, {color: theme.colors.onBackground}]}>
            ¡Entrega Exitosa!
          </Text>

          <Text style={[styles.message, {color: theme.colors.onSurfaceVariant}]}>
            El beneficio ha sido entregado correctamente
          </Text>
        </View>

        {/* Action Buttons */}
        <View style={[styles.actions, {backgroundColor: theme.colors.background}]}>
          <ActionButton
            icon="qr-code-scanner"
            label="Escanear Otro"
            variant="outlined"
            onPress={handleScanAnother}
            flex={1}
          />
          <ActionButton
            icon="home"
            label="Ir al Inicio"
            variant="contained"
            onPress={handleGoToDashboard}
            flex={1}
          />
        </View>
      </View>
    </MainLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  iconContainer: {
    width: 140,
    height: 140,
    borderRadius: 70,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 32,
  },
  title: {
    fontSize: 34,
    fontWeight: 'bold',
    marginBottom: 12,
    textAlign: 'center',
  },
  message: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 48,
    lineHeight: 28,
  },
  actions: {
    flexDirection: 'row',
    gap: 12,
    paddingHorizontal: 16,
    paddingTop: 20,
    paddingBottom: 32,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: -2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 5,
  },
});
